import React, { Component } from "react";
import { connect } from "dva";
import { modelUtils } from "@/utils";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import { ExamAuthSelect } from "../../../online";

let { Session } = utils_tool;
let {
  WizButton,
  WizCard,
  WizModal,
  WizAntdForm,
  WizCustomSteps,
  WizRow,
  WizCol,
} = component_tool;
let { WizContainer } = framework_tool;
import { Form, Spin } from "antd";
const getParamRecord = (history) => {
  let record = {};
  let id = 0;
  let copyExam = false;
  let copyExamId = 0;
  let header = [];
  let current = 0;
  let savePath = 'exam'
  let nextFunc = '/online/examTemplateGroup'
  let pathUrl = ''
  if (history.location) {
    if (history.location.pathname === "/online/exam/examAuth"
      || history.location.pathname === '/online/examTemplateGroup/examTemplateAuth'
    ) {
      if (history.location && history.location.record) {
        nextFunc = history.location.record['nextFunc'];
        id = history.location.record["id"];
        copyExam = history.location.record["copyExam"];
        copyExamId = history.location.record["copyExamId"];
        header = history.location.record["header"];
        current = history.location.record["current"];
        type = history.location.record["type"];
        pathUrl = history.location.record["pathUrl"];
        savePath = history.location.record["savePath"] ? history.location.record["savePath"] : 'exam';
        record = { id, copyExam, copyExamId, header, current, savePath, nextFunc, pathUrl };
        Session.set("examChapterInfo", record);
      } else {
        record = Session.get("examChapterInfo") || 0;
      }
    }
  } else {
    record = Session.get("examChapterInfo") || 0;
  }
  return record;
};
class ExamAuth extends WizContainer {
  componentName = "examAuth";

  constructor(props) {
    super(props);
    const { id, copyExam, copyExamId, header, current, savePath, nextFunc, pathUrl } = getParamRecord(props.history);
    this.state = {
      id,
      copyExam,
      copyExamId,
      initialValue: {},
      header,
      current,
      savePath,
      nextFunc,
      pathUrl
    };
  }

  //START propsAndStateOnChange
  propsAndStateOnChange = {
    authInfo: this._authInfo.bind(this),
    saveAuthKey: this._saveAuthKey.bind(this),
    examTemplateGroupInfo: this._examTemplateGroupInfo.bind(this)
  };

  _examTemplateGroupInfo(nextProps, nextState) {
    let { examTemplateGroupInfo } = nextProps
    this.setState({ examTemplateGroupInfo: examTemplateGroupInfo })
  }

  _saveAuthKey(nextProps, nextState) {
    let { saveAuthKey } = nextProps;
    let { id } = nextState
    if (saveAuthKey && saveAuthKey["success"]) {
      wizNotice.success(saveAuthKey["msg"]);
      let authUpd = saveAuthKey["data"]
      if (authUpd) {
        if (authUpd > 0) {

          WizModal.confirm({
            title: '注意', content: "消息通知内容有变更，是否重新发送消息通知", cancelText: "否", okText: "是",
            onOk: () => {
              this.doActions([
                {
                  path: "notice/sendNotice",
                  payload: {
                    key: "sendNoticeKey",
                    apiParams: {
                      bizId: id,
                      bizType: 1,
                      resend: true
                    },
                  },
                },
              ]);
              if (this.state.nextFunc) {
                this.jumpPage("replaceAndDelCrumb", this.state.nextFunc);
              } else {
                this.jumpPage("replaceAndDelCrumb", "/online/" + this.state.savePath);
              }
            },
            onCancel: () => {
              this.doActions([
                {
                  path: "notice/sendNotice",
                  payload: {
                    key: "sendNoticeKey",
                    apiParams: {
                      bizId: id,
                      bizType: 1,
                      resend: false
                    },
                  },
                },
              ]);
              if (this.state.nextFunc) {
                this.jumpPage("replaceAndDelCrumb", this.state.nextFunc);
              } else {
                this.jumpPage("replaceAndDelCrumb", "/online/" + this.state.savePath);
              }
            }
          });
        } else {
          this.doActions([
            {
              path: "notice/sendNotice",
              payload: {
                key: "sendNoticeKey",
                apiParams: {
                  bizId: id,
                  bizType: 1,
                  resend: false
                },
              },
            },
          ]);
          if (this.state.nextFunc) {
            this.jumpPage("replaceAndDelCrumb", this.state.nextFunc);
          } else {
            this.jumpPage("replaceAndDelCrumb", "/online/" + this.state.savePath);
          }
        }
      } else {
        if (this.state.nextFunc) {
          this.jumpPage("replaceAndDelCrumb", this.state.nextFunc);
        } else {
          this.jumpPage("replaceAndDelCrumb", "/online/" + this.state.savePath);
        }
      }

      return true;
    } else {
      wizNotice.error(
        (saveAuthKey && saveAuthKey["msg"]) || "操作失败,请稍后尝试"
      );
      return false;
    }
  }

  _authInfo(nextProps, nextState) {
    let { authInfo } = nextProps;
    if (authInfo && authInfo["success"]) {
      // let authInfoSave = authInfo?.data
      // if(authInfo?.data?.groupId?.id){
      //   authInfoSave.groupId = [{...authInfo.data.groupId}]
      // }else{
      //   authInfoSave.groupId = []
      // }
      // nextState.initialValue = authInfoSave
      nextState.initialValue = authInfo["data"]

      return true;
    } else {
      wizNotice.error((authInfo && authInfo["msg"]) || "操作失败,请稍后尝试");
    }
    return false;
  }

  _componentDidMount() {
    const { id, copyExam, copyExamId, savePath } = this.state;
    this.doActions([
      {
        path: savePath + "/authInfo",
        payload: {
          key: "authInfoKey",
          apiParams: {
            id: copyExam ? copyExamId : id,
          },
        },
      },
      {
        path: 'examTemplateGroup/getExamTemplateGroupById',
        payload: {
          key: 'examTemplateGroup@getById',
          apiParams: {
            id: id
          }
        }
      }
    ]);
  }

  stepView = () => {
    const { initialValue, id, savePath, examTemplateGroupInfo, pathUrl } = this.state;
    const selectProps = {
      path: this.props.history.location.pathname,
      examTemplateGroupInfo: examTemplateGroupInfo,
      id: this.state.id,
      initialValue: initialValue,
      submit: (value, status) => {
        let saveRequest = {};
        if (value["dataAuth"]) {
          let dataAuth = value["dataAuth"];
          if (dataAuth && dataAuth.isAll) {
            saveRequest.isAll = dataAuth.isAll
          }
          if (dataAuth["groupId"] && dataAuth["groupId"].length) {
            saveRequest["groupId"] = dataAuth["groupId"].map((p) => p["id"]).toString();
          } else if (dataAuth["groupId"] && dataAuth["groupId"]["id"]) {
            saveRequest["groupId"] = dataAuth["groupId"]["id"].toString();
          }
          else {
            saveRequest["orgIds"] = dataAuth["orgIds"] && dataAuth["orgIds"].map((p) => p["id"]);
            saveRequest["positionIds"] = dataAuth["positionIds"] && dataAuth["positionIds"].map((p) => p["id"]);
            saveRequest["positionCategoryIds"] = dataAuth["positionCategoryIds"] && dataAuth["positionCategoryIds"].map((p) => p["id"]);
            saveRequest["personIds"] = dataAuth["personIds"] && dataAuth["personIds"].map((p) => p["id"]);
          }
        }

        saveRequest["id"] = id;
        saveRequest['status'] = status;
        this.doAction({
          path: savePath + "/saveAuth",
          payload: {
            key: "examSaveAuthKey",
            apiParams: {
              ...saveRequest,
            },
          },
        });
      },
      prev: (values) => {
        if (this.props.history.location.pathname == '/online/exam/examAuth') {
          let { copyExam = '', copyExamId = '', type = '', pathUrl = '' } = this.state
          this.jumpPage(
            'replaceAndDelCrumb',
            'examChapter',
            {
              id: id, copyExam: copyExam, copyExamId: copyExamId,
              type: type,
              pathUrl: pathUrl
            }
          )
        } else {
          let pathname = 'examTemplateGroupDetailAdd'
          if (pathUrl && pathUrl === 'examTemplateGroup/update') {
            pathname = 'examTemplateGroupDetailUpd'
          }
          let record = values.data
          this.jumpPage(
            'replace',
            '/online/examTemplateGroup/' + pathname,
            { id: id, ...record }
          )
        }

      }
    };

    return <ExamAuthSelect {...selectProps} />;
  };

  _render() {
    const { header, current, savePath } = this.state
    let loading = this.props[savePath + 'Loading']
    let wizCustomStepsProps = {
      header: header && header.length ? header : [
        { title: "考试信息" },
        { title: "考试章节" },
        { title: "受众设置" },
      ],
      current: current ? current : 2,
      content: this.stepView(),
      footer: null,
    };
    return (
      <Spin tip={"加载中"} spinning={loading}>
        <WizCustomSteps {...wizCustomStepsProps} />
      </Spin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { examTemplateGroup } = state
  let savePath = 'exam'
  let record = ownProps.history.location['record'] || Session.get("examChapterInfo")
  if (record && record['savePath']) {
    savePath = record['savePath']
  }
  let exam = state[savePath];
  const authInfo = modelUtils.getModelEntity(exam, "authInfoKey");
  const saveAuthKey = modelUtils.getModelEntity(exam, "examSaveAuthKey");
  const examTemplateGroupInfo = modelUtils.getModelEntity(examTemplateGroup, "examTemplateGroup@getById")
  const load = modelUtils.getLoadingState(state, [savePath]);
  return {
    authInfo,
    saveAuthKey,
    examTemplateGroupInfo,
    ...load,
  };
};

export default connect(mapStateToProps)(ExamAuth);
